import { render, staticRenderFns } from "./RemainderOfEstateCard.vue?vue&type=template&id=0b60057c"
import script from "./RemainderOfEstateCard.vue?vue&type=script&lang=js"
export * from "./RemainderOfEstateCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports